import { buildMessageHandler, buildCloseHandler } from "../../common";
import { ConnectionNames } from "../../contracts";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
export function sportsSocketConnectionHandlers(rqFormatter, rsFormatter) {
    return {
        open: (x) => x,
        close: buildCloseHandler(ConnectionNames.sports, SDQuerySubscribersStore),
        message: buildMessageHandler(SDQuerySubscribersStore),
        error: (x) => x,
        requestFormatter: rqFormatter,
        responseFormatter: rsFormatter,
    };
}
//# sourceMappingURL=sportsSocketConnectionHandlers.js.map